import {Inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {TableSourceEnum, VehicleDataEnum} from "../models/VehicleData-model";

@Injectable({
    providedIn: 'root'
})
export class VehicleDataService {

    private url = `${this.API_URL}`;

    constructor(@Inject('API_URL') private API_URL: string, private httpClient: HttpClient) {
    }

    searchForVehicleData(
        field: VehicleDataEnum | 'TUNING_NAME',
        search: string,
        source: TableSourceEnum | 'TUNING_NAMES'
    ) {
        return this.httpClient.get<string[]>(`${this.url}/vehicle-data/search`, {
            params: {
                field,
                search,
                source
            },
            observe: "response"
        });
    }

    getCorrectVehicleProducers() {
        return this.httpClient.get<string[]>(`${this.url}/vehicle-producer/correct`, {
            observe: "response"
        });
    }

    getCorrectVehicleTypes() {
        return this.httpClient.get<string[]>(`${this.url}/vehicle-type/correct`, {
            observe: "response"
        });
    }

}
